import React, { ReactNode, useMemo } from 'react'
import { Form, message } from 'antd'
import DrawerForm from 'components/common/form/DrawerForm'

interface Ret00caFormProps {
  ret00cId: string
  record?: any
  buttonType?: "primary" | "default" | "dashed" | "link" | "text"
  buttonText?: string | ReactNode
  submitSuccess?: (e: any) => void
}

export const ret00caFormData = [
  {
    key: 'id',
    label: 'ID',
    type: 'input',
    hidden: true,
  },
  {
    key: 'param_scope',
    label: '参数位置',
    type: 'select',
    rules: [{ required: true, message: '请选择参数位置' }],
    formItemClassName: 'col-span-1 md:col-span-2',
    options: [
      { label: '请求头', value: 'header' },
      { label: 'Query 参数', value: 'query' },
      { label: 'Path 参数', value: 'path' },
      { label: '请求体', value: 'body' },
      { label: '返回参数', value: 'response' },
    ],
  },
  {
    key: 'name',
    label: '参数名',
    type: 'input',
    rules: [{ required: true, message: '请输入参数名' }],
    formItemClassName: 'col-span-1 md:col-span-3',
  },
  {
    key: 'display_name',
    label: '中文名',
    type: 'input',
    formItemClassName: 'col-span-1 md:col-span-3',
  },
  {
    key: 'data_type',
    label: '数据类型',
    type: 'select',
    rules: [{ required: true, message: '请选择数据类型' }],
    formItemClassName: 'col-span-1 md:col-span-2',
    options: [
      { label: 'string', value: 'string' },
      { label: 'integer', value: 'integer' },
      { label: 'decimal', value: 'decimal' },
      { label: 'boolean', value: 'boolean' },
      { label: 'object', value: 'object' },
      { label: 'array', value: 'array' },
      { label: 'file', value: 'file' },
      { label: 'float', value: 'float' },
    ],
  },
  {
    key: 'required',
    label: '必填',
    type: 'switch',
    valuePropName: 'checked',
    formItemClassName: 'col-span-1 md:col-span-2',
  },
  {
    key: 'enabled',
    label: '启用',
    type: 'switch',
    valuePropName: 'checked',
    formItemClassName: 'col-span-1 md:col-span-2',
  },
  {
    key: 'description',
    label: '说明',
    type: 'textarea',
    rows: 3,
    formItemClassName: 'col-span-1 md:col-span-6',
  },
]

function Ret00caForm({ ret00cId, record, buttonText, buttonType, submitSuccess }: Ret00caFormProps): JSX.Element {
  const [form] = Form.useForm()
  const submitPath = record ? `/console/ret00cs/${ret00cId}/ret00cas/${record.id}` : `/console/ret00cs/${ret00cId}/ret00ca_create`
  const submitMethod = record ? 'PUT' : 'POST'

  const data = useMemo(() => (
    record || {
      param_scope: 'query',
      required: true,
      enabled: true,
      data_type: 'string',
    }
  ), [record])
  const formData = useMemo(() => ret00caFormData, [])

  return (
    <DrawerForm
      title={record ? '编辑参数' : '新增参数'}
      submitPath={submitPath}
      submitMethod={submitMethod}
      buttonType={buttonType}
      buttonText={buttonText}
      submitSuccess={(e) => {
        message.success('操作成功')
        submitSuccess?.(e)
      }}
      form={form}
      drawerProps={{
        width: 720,
      }}
      wrapperClassNames='grid grid-cols-1 md:grid-cols-12 gap-x-4'
      data={data}
      formData={formData}
    />
  )
}

export default Ret00caForm
